import { ApiHelper } from '../apiHelper';
import { IPagination, IQuery } from '../../models/athena';
import { Observable } from 'rxjs';
import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';

export class BigQueryDAO extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BIGQUERY, apiHelper);
  }

  public query(query: string, pagination?: IBigQueryPagination): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/query';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, { query, ...pagination }, headers);
  }
}

export interface IBigQueryPagination {
  pageSize?: number;
  pageToken?: string;
}
